export default {
  template: "#vue-map-component",
  delimiters: ["${", "}"],
  data: function () {
    return {
      map: null,
      moved: false,
      markers_string: '',
      marker_object: {},
      pin_height: 32,
      pin_width: 22,
      pins: [],
      previous_active_store: null
    };
  },
  created() {
    this.$store.commit('registerComponent', {name: 'map', component: this})
  },
  props: {
    stores: {
      type: Array,
      default: []
    },
    center: {
      type: Object,
      default: {
        lat: 56.1304,
        lng: -106.3468
      },
    },
    zoom: {
      type: Number,
      default: 8
    },
    marker: String,
    marker_png: String
  },
  methods: {
    createPins() {
      let ex_pins = this.pins.map(e => {
        return e.store_number
      })
      for (let store of this.stores) {
        if (!ex_pins.includes(store.store_number)) {
          let new_pin = {
            latitude: store.latitude,
            longitude: store.longitude,
            store_number: store.store_number,
            isActive: false,
            marker: new google.maps.Marker({
              position: new google.maps.LatLng(store.latitude, store.longitude),
              map: this.map,
              icon: {
                url: this.marker,
                scaledSize: new google.maps.Size(this.pin_width, this.pin_height)
              }
            })
          }
          new_pin.marker.addListener('click', () => {
            this.activeLocation(new_pin.store_number, true);
            this.showLocationDetails(new_pin.store_number);
          });
          this.pins.push(new_pin)
        }
      }
      let new_stores = this.stores.map(e => {
        return e.store_number
      })
      for (let pin of this.pins) {
        if (!new_stores.includes(pin.store_number)) {
          if (pin.marker.visible) {
            pin.marker.setVisible(false)
          }
        } else if (!pin.marker.visible) {
          pin.marker.setVisible(true)
        }
      }

      // check the new pin list - if none of the newly drawn pins will be contained within the maps current bounds,
      // we will rescale the map. otherwise we just leave as-is
      const new_bounds = new google.maps.LatLngBounds();
      const current_bounds = this.map.getBounds()
      let contains_pin = false
      this.pins.map(e => {
        if (e.marker.visible) {
          new_bounds.extend(e.marker.position);
          if (!contains_pin && current_bounds && current_bounds.contains(e.marker.getPosition())) {
            contains_pin = true
          }
        }
      })
      if (!contains_pin) {
        new_bounds.extend(this.center)
        this.map.setCenter(new_bounds.getCenter());
        this.map.fitBounds(new_bounds)
      }
    },
    createMarkersString: function () {
      this.stores.forEach(s => {
        this.markers_string += "&markers=icon:http:" + this.marker_png + "%7C" + s.latitude + ',' + s.longitude;
      });
    },
    showLocationDetails(store_number) {
      if (store_number !== this.previous_active_store) {
        if (this.previous_active_store) {
          const ex = document.getElementsByClassName(`js-store-location-${this.previous_active_store}`)[0];
          if (ex) {
            ex.classList.remove('style_active_store');
          }
        }
        document.getElementsByClassName("js-store-location-" + store_number)[0].classList.add('style_active_store');

        document.getElementsByClassName("style_active_store")[0].scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
        this.previous_active_store = store_number;
      }
    },
    activeLocation(store_number, center) {
      this.pins.map(pin => {
        if (pin.isActive && pin.store_number !== store_number) {
          pin.isActive = false
          pin.marker.setIcon({
            url: this.marker,
            scaledSize: new google.maps.Size(this.pin_width, this.pin_height)
          })
        }
      })
      let active_pin = this.pins.filter(pin => pin.store_number === store_number)[0];
      active_pin.isActive = true;
      active_pin.marker.setIcon({
        url: this.marker,
        scaledSize: new google.maps.Size(32, 46)
      });
      if (center) {
        this.map.setZoom(12);
        this.map.panTo({lat: active_pin.latitude, lng: active_pin.longitude});
        document.getElementsByClassName("js-map")[0].scrollIntoView({behavior: 'smooth', block: 'nearest'});
      }
    },
    searchThisArea: function () {
      this.$store.state.global_components.store_locator.updateClosestStores(this.center.lat, this.center.lng)
      this.moved = false;
    },
    recenter: function () {
      if (this.$store.state.location.latitude && this.$store.state.location.longitude) {
        this.center.lat = this.$store.state.location.latitude
        this.center.lng = this.$store.state.location.longitude
        this.map.setCenter(this.center)
        this.$store.state.global_components.store_locator.updateClosestStores(this.center.lat, this.center.lng);
        this.moved = false;
      }
    },
    init_map() {
      if (typeof google === 'undefined') {
      } else if (document.getElementById("map") === null) {
      } else {
        this.map = new google.maps.Map(document.getElementById("map"), {
          center: this.center,
          zoom: this.zoom,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false
        });

        this.map.addListener("dragend", () => {
          this.moved = true;
          this.center.lat = this.map.getCenter().lat();
          this.center.lng = this.map.getCenter().lng();
        });
        this.createPins();
        clearInterval(this.interval_id)
      }
    }
  },
  mounted() {
    this.$store.dispatch('getLocation').then(
        resp => {
          this.interval_id = setInterval(this.init_map, 10)
        },
        () => {
        })
  },
  watch: {
    stores() {
      if (this.map !== null) {
        this.createPins();
        this.activeLocation(this.stores[0].store_number, true);
      }
    }
  }
}